import React from 'react';
import { Filter, Settings } from 'lucide-react';

export function CategoryFilter({ filtroCategoria, setFiltroCategoria, categoriasTarefas, onOpenCategorias }) {
  return (
    <div className="flex items-center gap-2 mb-4 flex-wrap" data-testid="filtro-categorias">
      <Filter className="h-4 w-4 text-stone-400" />
      <button
        onClick={() => setFiltroCategoria('todas')}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
          filtroCategoria === 'todas' ? 'bg-stone-800 text-white' : 'bg-stone-100 text-stone-600 hover:bg-stone-200'
        }`}
        data-testid="filtro-todas"
      >
        Todas
      </button>
      {categoriasTarefas.map(cat => (
        <button
          key={cat.id}
          onClick={() => setFiltroCategoria(cat.id)}
          className="px-3 py-1 rounded-full text-sm font-medium transition-colors"
          style={{
            backgroundColor: filtroCategoria === cat.id ? cat.cor : `${cat.cor}15`,
            color: filtroCategoria === cat.id ? 'white' : cat.cor
          }}
          data-testid={`filtro-cat-${cat.id}`}
        >
          {cat.nome}
        </button>
      ))}
      <button
        onClick={onOpenCategorias}
        className="px-3 py-1 rounded-full text-sm font-medium border border-dashed border-stone-300 text-stone-500 hover:border-stone-400 hover:text-stone-700 transition-colors flex items-center gap-1"
        data-testid="gerir-categorias-btn"
      >
        <Settings className="h-3 w-3" />Gerir
      </button>
    </div>
  );
}
